import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { URL_Route } from "urlRouts";
import { setInitialStateAction } from "ReduxSaga/actions/UserActions";
import { useDispatch } from "react-redux";
import Cookies from "universal-cookie";

const Logout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cookies = new Cookies();

  useEffect(() => {
    cookies.remove("token");
    cookies.remove("refreshToken");
    dispatch(setInitialStateAction());
    navigate(URL_Route.Login);
  }, []);
};

export default Logout;
